import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import axios from 'axios'
import { bannerUrl } from 'common/endpoints'
import { isDev } from 'config/api.config'

import banners from './InternalBanners'
import { StyledExternalBanner } from './StyledBanner'

// https://nookybuddies.com.branch9.preview.dp-core.com/api/banners?instanceId=3&devMode=0
// { redirTo: "//rev.datingfactory.com/delivery/ajs.php?zoneid=98&v_profile_age=414&v_sex=man&v_membership=MEMBERSHIP_STATUS.GOLD" }

// var OX_5cf17cb5 = '';
// OX_5cf17cb5 += "\"<"+"script type=\"\"text/javascript\"\">\n";
// OX_5cf17cb5 += "var ad_idzone = \"\"3409781\"\",\n";
// OX_5cf17cb5 += "ad_width = \"\"300\"\",\n";
// OX_5cf17cb5 += "ad_height = \"\"250\"\";\n";
// OX_5cf17cb5 += "<"+"/script>\n";
// OX_5cf17cb5 += "<"+"script type=\"\"text/javascript\"\" src=\"\"https://ads.exosrv.com/ads.js\"\"><"+"/script>\n";
// OX_5cf17cb5 += "<"+"noscript><"+"iframe src=\"\"https://syndication.exosrv.com/ads-iframe-display.php?idzone=3409781&output=noscript&type=300x250\"\" width=\"\"300\"\" height=\"\"250\"\" scrolling=\"\"no\"\" marginwidth=\"\"0\"\" marginheight=\"\"0\"\" frameborder=\"\"0\"\"><"+"/iframe><"+"/noscript>\"<"+"div id=\'beacon_1adc84ed7a\' style=\'position: absolute; left: 0px; top: 0px; visibility: hidden;\'><"+"img src=\'http://rev.datingfactory.com/delivery/lg.php?bannerid=18&amp;campaignid=12&amp;zoneid=98&amp;loc=http%3A%2F%2Flocalhost%3A8080%2F&amp;cb=1adc84ed7a\' width=\'0\' height=\'0\' alt=\'\' style=\'width: 0px; height: 0px;\' /><"+"/div>\n";
// document.write(OX_5cf17cb5);

class Banner extends Component {
  state = {};

  loadExternal = instanceId => {
    const { disableAds, testAds, realAds } = this.props.flags
    const devMode = realAds ? 0 : testAds ? 1 : +isDev

    disableAds ||
      window.Cypress ||
      axios
        .get(bannerUrl(instanceId, devMode))
        .then(res => axios.get(res.data.redirTo, { withCredentials: false }))
        .then(
          res => {
            const _write = document.write
            document.write = html => {
              // clean double quotes + "<script...>...</noscript>"<div quotes
              html = html
                .replace(/(\\?")+/g, (m, g1) => m.slice(0, g1.length))
                .replace(/^\\?"|\\?"(?=<div id=.?.?beacon)/g, '')

              // leave only iframe and beacon, while supplying extra JS params
              html = html
                .replace(/.*<noscript>|<\/noscript>/g, '')
                .replace(
                  '&output=noscript',
                  `&p=${escape(document.URL)}&screen_resolution=${screen.width}x${screen.height}`
                )

              this.setState({ html })
            }
            eval(res.data) // ajax + eval used instead of <script> load in order to modify document.write for the ad execution only
            document.write = _write
          },
          error => {
            if (error.request?.status == 0) {
              console.warn('Banner request blocked - likely due to adblocker')
              this.setState({ html: '<!-- Banner blocked -->' })
            }
          }
        )
  };

  loadInternal = () => {
    const options = banners.filter(b => b.condition(this.props.profile, this.props.flags))
    const InternalBanner = options[Math.floor(Math.random() * options.length)]?.component

    this.setState({ InternalBanner })
  };

  load = () => (this.props.external ? this.loadExternal(this.props.instanceId) : this.loadInternal());

  componentDidMount() {
    this.load()
  }

  componentDidUpdate({ flags }) {
    if (['disableAds', 'realAds', 'testAds'].some(e => this.props.flags[e] !== flags[e])) {
      this.load()
    }
  }

  render() {
    const { external, flags, fallback } = this.props
    if (external) {
      return (
        !flags.disableAds && <StyledExternalBanner dangerouslySetInnerHTML={{ __html: this.state.html || fallback }} />
      )
    }
    const { InternalBanner } = this.state
    return !!InternalBanner && <InternalBanner />
  }
}

const mapStateToProps = ({ myProfile, flags }) => ({ profile: myProfile, flags })

export default withRouter(connect(mapStateToProps)(Banner))
